
import { mapActions, mapState, mapGetters } from 'vuex'
import flatten from 'lodash/flatten'

export default {
  async asyncData({ store }) {
    await store.dispatch('cart/load', {
      root: true,
    })
  },

  head() {
    return {
      title: this.$t('shopping-cart'),
    }
  },

  computed: {
    ...mapState('cart', ['cart']),
    ...mapGetters('cart', ['itemsInCart', 'allowedPaymentMethods']),

    paymentIcons() {
      const icons = flatten(
        Object.entries(this.allowedPaymentMethods).map(
          ([, config]) => config.icons
        )
      )

      return icons
    },

    hasItemsInCart() {
      return this.itemsInCart > 0
    },

    alreadyBoughtTestLicenses() {
      return this.cart?.already_bought_test_licenses ?? null
    },

    hasAlreadyBoughtTestLicenses() {
      return this.alreadyBoughtTestLicenses.length > 0
    },
  },

  methods: {
    ...mapActions('cart', ['load', 'add', 'remove']),
    async goToCheckout() {
      await this.load()
      if (this.hasItemsInCart) {
        this.$router.push('/checkout')
      } else {
        this.$toast.info(this.$t('order.no-items-in-cart'))
      }
    },
  },
}
